import { AppRoutes } from './routes';
import { AppProvider } from '@/lib/core/providers/appProvider';
import { useLocaleStore } from '@/lib/core/stores';
import { useDeepLink } from '@/lib/core/hooks/useDeepLink';
import { useCartCountSync } from '@/lib/core/hooks/useCartCountSync';
import { useActiveRideTracking } from '@/lib/core/hooks/useActiveRideTracking';
import { useSfmcContactKeySync } from '@/lib/core/hooks/useSfmcContactKeySync';
import { useSfmcPushPermissionSync } from '@/lib/core/hooks/useSfmcPushPermissionSync';
import { IntlProvider } from '@/lib/core/i18n';

export default function App() {
  const locale = useLocaleStore(state => state.locale);
  useDeepLink();
  useCartCountSync();
  useActiveRideTracking();
  useSfmcContactKeySync();
  useSfmcPushPermissionSync();

  return (
    <IntlProvider locale={locale}>
      <AppProvider locale={locale}>
        <AppRoutes />
      </AppProvider>
    </IntlProvider>
  );
}
